import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c6227d34&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "../../style.scss?vue&type=style&index=0&id=c6227d34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6227d34",
  null
  
)

export default component.exports